module.exports = __webpack_public_path__ + "img/comp_list.206eac4b.png";